import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';

const CategoryEventsSkeleton = () => {
  return (
    <div className='flex flex-col md:flex-row justify-center flex-wrap gap-6'>
      {[...Array(8)]?.map((_, index: number) => (
        <Skeleton
          key={index}
          className='w-full md:w-[45%] lg:w-[28%] xl:w-[22%] h-72 rounded-2xl'
        />
      ))}
    </div>
  );
};

export default CategoryEventsSkeleton;
